import React, { Component } from "react";
import { connect } from "react-redux";
import firebase from "../firebase";
import { browserHistory } from "react-router";
import { ACCOUNT_MANAGEMENT_URL } from "../config";

export default (WrappedComponent) => {
  class RequireAuth extends Component {
    state = {
      user: null,
    };

    static contextTypes = {
      router: React.PropTypes.object,
    };

    componentDidMount() {
      this.unsubscribeAuthListener = firebase
        .auth()
        .onAuthStateChanged((user) => {
          if (!user) {
            console.log("Navigating to login...");
            const currentLocation = this.props.location;
            const loginLocation = {
              pathname: "/signup",
              state: { from: currentLocation },
            };
            return browserHistory.push(loginLocation);
          }
          this.setState({
            user,
          });
        });
    }

    componentWillUnmount() {
      this.unsubscribeAuthListener();
    }

    render() {
      if (!this.state.user) {
        return <div />;
      }

      return (
        <WrappedComponent {...this.props} firebaseUser={this.state.user} />
      );
    }
  }

  function mapStateToProps(state) {
    return {
      authenticated: state.auth.authenticated,
    };
  }

  return connect(mapStateToProps)(RequireAuth);
};



// WEBPACK FOOTER //
// ./src/components/requireAuth.js